import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { Input, Popup } from "semantic-ui-react";
import { setPlayStoreClientDetails } from "../../../../../actions/authAction";
import Modal from "../../../../UIComponents/CustomModal/Modal";
import "./PlaystoreModal.scss";
import { changeGoogleCLientId } from "../../../../../actions/globalAction";
import { ReactComponent as InfoIcon } from "../../../../../assets/svg/info-icon.svg";

const PlaystoreClientDetailsModal = (props) => {
    const [clientSecret, setClientSecret] = useState("");
    const [clientId, setClientId] = useState("");
    const dispatch = useDispatch();

    const hideModal = () => {
        props.hideModal();
    };

    const handleSave = async () => {
        if (clientId.trim() == "") {
            toast.error("Please enter your client id");
            return;
        }

        if (clientSecret.trim() == "") {
            toast.error("Please enter your client secret");
            return;
        }

        await dispatch(changeGoogleCLientId(clientId.trim()));

        let obj = {
            playstoreClientSecret: clientSecret.trim(),
            playstoreClientId: clientId.trim(),
        };
        dispatch(setPlayStoreClientDetails(obj));

        console.log("clientId", clientId);
        console.log("clientSecret", clientSecret);
        props.authenticatePlaystore();
        // storeToken();
        hideModal();
    };

    return (
        <Modal className={`canned-block`} show={props.open} onClose={hideModal}>
            <Modal.Header>Google Play Store</Modal.Header>
            <Modal.Content className="canned-block-container">
                <div className="category-conatiner">
                    <p>Please enter your Client Id</p>
                    {/* <Popup
                        className="infoPopup skiptranslate"
                        position="bottom center"
                        // header={name}
                        size="mini"
                        content="add info"
                        trigger={
                            <div className="info-icon" data-html2canvas-ignore="true">
                                <InfoIcon />
                            </div>
                        }
                        style={{ zIndex: "99999" }}
                    /> */}
                </div>
                <div className="canned-block-title-input ">
                    <Input className="field" placeholder="Client ID" type="text" onChange={(e) => setClientId(e.target.value)} value={clientId} required />
                </div>
                <div className="category-conatiner">
                    <p>Please enter your Client Secret</p>
                    {/* <Popup
                        className="infoPopup skiptranslate"
                        position="bottom center"
                        size="mini"
                        content="add info"
                        trigger={
                            <div className="info-icon" data-html2canvas-ignore="true">
                                <InfoIcon />
                            </div>
                        }
                        style={{ zIndex: "99999" }}
                    /> */}
                </div>
                <div className="canned-block-title-input ">
                    <Input
                        value={clientSecret}
                        type="text"
                        className="field"
                        placeholder="Client Secret"
                        maxLength="50"
                        onChange={(e) => setClientSecret(e.target.value)}
                        required
                    />
                </div>
            </Modal.Content>
            <Modal.Actions>
                <Modal.ActionButton normal onClick={hideModal}>
                    Cancel
                </Modal.ActionButton>
                <Modal.ActionButton filled onClick={handleSave}>
                    Save
                </Modal.ActionButton>
            </Modal.Actions>
        </Modal>
    );
};

export default PlaystoreClientDetailsModal;
